import React from 'react'
import { useSelector } from 'react-redux'

import CompanyTemplate from '../../templates/Company'
import { selectors as AppSelectors } from '../../redux/app/redux'
import withMemo from '../../decorators/WithMemo'

import CompanySagas from './sagas'
import { selectors } from './redux'


const Company = () => {
  const data = useSelector(selectors.data)
  const isLoaded = useSelector(selectors.isLoaded)
  const breadcrumb = useSelector(AppSelectors.breadcrumb)

  if (data === null || isLoaded === false) {
    return null
  }

  return (
    <CompanyTemplate
      data={data}
      breadcrumb={breadcrumb}
    />
  )
}

Company.getInitialProps = async(ctx, store) => (
  store.saga.run(CompanySagas.init, ctx).done
)

Company.propTypes = {}

export default withMemo()(Company)
